import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogOut, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { homePath } from "@/components/nav";
import { api, errMsg } from "@/lib/api";

export default function CompanyPicker() {
  const { session, can, switchTenant, logout } = useAuth();
  const nav = useNavigate();
  const [list, setList] = useState(null);
  useEffect(() => {
    if (session && can("platform:switch")) api.get("/auth/tenants").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [session]); // eslint-disable-line react-hooks/exhaustive-deps
  if (session === null) return <Loading />;
  if (!session) return <Navigate to="/login" replace />;
  if (!can("platform:switch")) return <Navigate to={homePath(session)} replace />;
  const pick = async (id) => {
    try { nav(homePath(await switchTenant(id))); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sheet-bg text-white px-6 py-5 flex items-center justify-between">
        <div>
          <div className="font-mono text-[11px] text-emerald-200">{session.user.role_label?.toUpperCase()}</div>
          <h1 className="font-display text-2xl font-bold">Pilih Perusahaan</h1>
        </div>
        <Button variant="outline" className="bg-transparent text-white border-white/40 hover:bg-white/10" onClick={async () => { await logout(); nav("/login"); }} data-testid="picker-logout"><LogOut className="h-4 w-4 mr-2" />Keluar</Button>
      </header>
      <main className="max-w-5xl mx-auto p-6">
        <p className="text-sm text-slate-600 mb-4">{session.user.platform_role === "collector" ? "Anda hanya bisa masuk ke perusahaan tempat Anda ditugaskan." : "Akses Anda berlaku untuk semua perusahaan."} Setiap perpindahan perusahaan tercatat di audit log.</p>
        {list && list.length === 0 && <div className="text-center text-slate-500 py-10 border border-dashed rounded-sm bg-white" data-testid="picker-empty">Anda belum ditugaskan ke perusahaan mana pun. Hubungi Pemilik, Supervisor, atau Admin Utama.</div>}
        {!list ? <Loading /> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 fade-up">
            {list.map((t) => (
              <button key={t.id} onClick={() => pick(t.id)} className="group text-left bg-white border border-slate-300 rounded-sm p-4 hover:border-emerald-600 hover:bg-emerald-50 transition-colors" data-testid={`pick-tenant-${t.name}`}>
                {t.logo ? <img src={t.logo} alt="" className="h-10 w-10 object-contain" /> : <div className="h-10 w-10 rounded-sm bg-emerald-100 text-emerald-800 font-display font-bold flex items-center justify-center">{t.nota_code}</div>}
                <div className="font-display font-semibold mt-3">{t.name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1"><Building2 className="h-3 w-3" />Kode {t.nota_code}</div>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
